import AIVoices from './aiVoices';

export default AIVoices;